import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  currentMessage = new BehaviorSubject<any>(null);
  apiUrl = environment.auth_url;

  constructor(private angularFireMessaging: AngularFireMessaging, private http: HttpClient) {
    console.log('MessagingService initialized');
  }

  requestPermission() {
    console.log('Requesting permission...');
    this.angularFireMessaging.requestToken.subscribe({
      next: (token) => {
        console.log('Token response:', token);
        if (token) {
          console.log('Permission granted. Token:', token);
          localStorage.setItem('fcmToken', token);
        } else {
          console.error('No token received');
        }
      },
      error: (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    });
  }

  receiveMessage() {
    console.log('Setting up message receiver...');
 this.angularFireMessaging.messages.subscribe({
   next: (payload: any) => {
     console.log("New message received. Payload:", payload);
     this.currentMessage.next(payload);
   },
   error: (err: any) => {
     console.error('Error receiving message:', err);
   },
   complete: () => {
     console.log('Message subscription completed');
   }
 });
  }

  // New method to check if messaging is supported
  checkMessagingSupport() {
    if ('Notification' in window) {
      console.log('Notifications are supported');
    } else {
      console.warn('Notifications are not supported in this browser');
    }

    if ('serviceWorker' in navigator) {
      console.log('Service Workers are supported');
    } else {
      console.warn('Service Workers are not supported in this browser');
    
  }
}

bindFcmToken(payload: any): Observable<any> {
  return this.http.post(`${this.apiUrl}/notification/v1/add-notifications-token`, payload);
}
}